import * as React from 'react';
import { Theme, StyleRules } from '@material-ui/core/styles';
import withStyles, { ClassNameMap } from '@material-ui/core/styles/withStyles';
import { Grid, Button } from '@material-ui/core';
import SnackbarsMessage from './SnackbarsMessage';
import { ApplyContent } from '../modules/apply';
import { ApplyTarget } from '../components';

interface Props {
  classes: ClassNameMap;
  contents: ApplyContent[];
  clearContents: () => void;
  oldCategories: { [key: string]: string };
  submitMessages: string[];
  submitErrorMessages: string[];
  onChangeCategory: (index: number, content: ApplyContent) => void;
  onApplyContents: (name: string, contents: ApplyContent[]) => Promise<void>;
  onClose: () => void;
}

interface State {
  applierName: string;
}

const style = (theme: Theme): StyleRules => ({
  textFiled: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
  },
  apply: {
    marginTop: theme.spacing.unit * 3,
  },
});

class Apply extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      applierName: '',
    };
  }

  handleChangeCategory = (index: number, category: number, content: ApplyContent) => {
    this.props.onChangeCategory(index, {
      fileName: content.fileName,
      orgTagId: content.orgTagId,
      newTagId: category,
      position: content.position,
      order: content.order,
      text: content.text,
    });
  }

  handleSubmitApplyContents = () => {
    const { contents, onApplyContents, onClose, clearContents } = this.props;
    const { applierName } = this.state;
    // if (applierName === '') {
    //   alert('申請者を入力してください。');
    // } else {
    onApplyContents(applierName, contents).then(() => {
      clearContents();
      onClose();
    });
    // }
  }

  handleChangeApplier = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const { value } = event.target;
    this.setState({ applierName: value });
  }

  render() {
    const {
      classes,
      contents,
      oldCategories,
      submitErrorMessages,
    } = this.props;
    return (
      <React.Fragment>
        <SnackbarsMessage
          variant="error"
          messages={submitErrorMessages}
        />
        <Grid
          container
          spacing={16}
          direction="column"
          alignItems="stretch"
        >
          {/* <Grid item>
            <TextField
              required
              id="applier_name"
              label="申請者"
              type="text"
              className={classes.textField}
              margin="normal"
              variant="outlined"
              value={this.state.applierName}
              onChange={this.handleChangeApplier}
            />
          </Grid> */}
          {contents.map((_, i) => (
          <Grid item key={i}>
            <ApplyTarget
              index={i}
              content={contents[i]}
              oldCategories={oldCategories}
              onChangeCategory={this.handleChangeCategory}
            />
          </Grid>
          ))}
        </Grid>
        <Grid
          container
          justify="center"
          className={classes.apply}
        >
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              onClick={this.handleSubmitApplyContents}
            >
              指摘内容送信
            </Button>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}
export default withStyles(style)(Apply);



// WEBPACK FOOTER //
// ./src/components/Apply.tsx